var _module_exports = "<button type=\"button\" class=\"submit\" ng-click=\"$ctrl.charge()\" ng-disabled=\"$ctrl.disabled || $ctrl.charging\" ng-class=\"$ctrl.btnClass\">\n  {{$ctrl.submitLabel }}\n</button>";
var path = '/var/www/rezflow/client/assets/scripts/modules/card/button.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngtemplate-loader!./client/assets/scripts/modules/card/button.tpl.html
// module id = 160
// module chunks = 0 1